var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-component',{ref:"headerComponent",attrs:{"id":"headerComponent"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer-component',{ref:"footerComponent",attrs:{"id":"footerComponent"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b0b4e3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 369
// module chunks = 0